export default class Labels {
    constructor() {
        // Archive labels

        this.toggleDropdown();
        this.selectActors();
        this.removeFilter();
    }

    toggleDropdown() {
        const form = document.querySelector('#hg_labels');
        if(form) {
            form.querySelector('.form__text').addEventListener('click', () => {
                form.classList.toggle('js-open');
            });

            form.querySelector('.form__overlay').addEventListener('click', () => {
                form.classList.remove('js-open');
            });
        }
    }

    selectActors() {
        const select = document.querySelector('#hg_acteur');
        const list = document.querySelector('#hg_actors');

        if(select && list) {
            list.querySelectorAll('.form__item').forEach((item) => {
                item.addEventListener('click', () => {
                    if(!item.classList.contains('js-selected')) {
                        item.classList.add('js-selected');
                        select.querySelector(`[value="${item.dataset.value}"]`).selected = 'selected';
                    } else {
                        item.classList.remove('js-selected');
                        select.querySelector(`[value="${item.dataset.value}"]`).selected = '';
                    }

                    this.setLabel();
                });
            });
        }
    }

    setLabel() {
        const btn = document.querySelector('#hg_labels .form__text');
        const select = document.querySelector('#hg_acteur');
        if(btn && select.querySelectorAll('option:checked').length > 0) {
            let content = '';
            select.querySelectorAll('option:checked').forEach((item, index) => {
                if(index !== 0) {
                    content = `${content}, ${item.textContent}`;
                } else {
                    content = item.textContent;
                }
            });
            btn.innerText = content;
        } else {
            btn.innerText = 'Tous les acteurs';
        }
    }

    removeFilter() {
        const btns = document.querySelectorAll('.tag [data-option]');
        if(btns.length > 0) {
            btns.forEach((btn) => {
                btn.addEventListener('click', () => {
                    btn.remove();
                    document.querySelector(`#hg_acteur [value="${btn.dataset.option}"]`).selected = '';
                    document.querySelector('#hg_labels').submit();
                });
            });
        }
    }
}